/* tslint:disable */
/* eslint-disable */
/**
 * Disponent.Online
 * Disponent.Online API
 *
 * The version of the OpenAPI document: 0.1
 * Contact: service@weberdata.de
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import globalAxios, { AxiosPromise, AxiosInstance } from 'axios';
import { Configuration } from '../configuration';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, RequestArgs, BaseAPI, RequiredError } from '../base';
// @ts-ignore
import { Message } from '../models';
// @ts-ignore
import { Translation } from '../models';
/**
 * TranslationService - axios parameter creator
 * @export
 */
export const TranslationServiceAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Liefert eine Liste von Translation
         * @summary Client Translations
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTranslations: async (options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/translations`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * TranslationService - functional programming interface
 * @export
 */
export const TranslationServiceFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = TranslationServiceAxiosParamCreator(configuration)
    return {
        /**
         * Liefert eine Liste von Translation
         * @summary Client Translations
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getTranslations(options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<Translation>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getTranslations(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * TranslationService - factory interface
 * @export
 */
export const TranslationServiceFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = TranslationServiceFp(configuration)
    return {
        /**
         * Liefert eine Liste von Translation
         * @summary Client Translations
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTranslations(options?: any): AxiosPromise<Array<Translation>> {
            return localVarFp.getTranslations(options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * TranslationService - interface
 * @export
 * @interface TranslationService
 */
export interface TranslationServiceInterface {
    /**
     * Liefert eine Liste von Translation
     * @summary Client Translations
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TranslationServiceInterface
     */
    getTranslations(options?: any): AxiosPromise<Array<Translation>>;

}

/**
 * TranslationService - object-oriented interface
 * @export
 * @class TranslationService
 * @extends {BaseAPI}
 */
export class TranslationService extends BaseAPI implements TranslationServiceInterface {
    /**
     * Liefert eine Liste von Translation
     * @summary Client Translations
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TranslationService
     */
    public getTranslations(options?: any) {
        return TranslationServiceFp(this.configuration).getTranslations(options).then((request) => request(this.axios, this.basePath));
    }
}
